const dataGridStyles = {
  width: "100%",
  fontSize: "15px",
  fontWeight: "500",

  "& .MuiDataGrid-root": {
    border: "none",
  },

  "& .MuiDataGrid-columnHeaders": {
    fontSize: "1rem",
    fontWeight: 600,
    minHeight: "56px !important",
    borderBottom: "1px solid #b0b0b0",
    whiteSpace: "nowrap",
    borderRight: "1px solid #b0b0b0",
  },

  "& .MuiDataGrid-columnHeader": {
    fontSize: "1.19rem",
    fontWeight: "500",
    height: "95px !important",
    borderRight: "1px solid #b0b0b0",
    padding: "0 4px",
  },

  "& .MuiDataGrid-iconButtonContainer": {
    visibility: "hidden !important",
    display: "none !important",
  },

  "& .header-bold": {
    fontWeight: "bold",
  },

  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: "bold",
    paddingTop: "10px",
    whiteSpace: "pre-line",        // 🔥 allows wrapping using "\n"
    lineHeight: 1.2,
    textAlign: "center",
    fontSize: "0.95rem",
  },

  "& .MuiDataGrid-columnHeaderTitleContainer": {
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    textAlign: "center",
  },

  "& .MuiDataGrid-cell": {
    fontSize: "1.1rem",
    fontWeight: "500",
    borderRight: "1px solid #b0b0b0",
    borderBottom: "1px solid #b0b0b0",
    paddingLeft: "8px",
    paddingRight: "8px",
    whiteSpace: "normal",           // 🔥 allows wrapping inside cell
    wordWrap: "break-word",
    // textAlign is now controlled by column align property
  },

  "& .MuiTablePagination-root": {
    fontSize: "1.18rem",
  },

  "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
    fontSize: "1.06rem",
  },

  "& .MuiDataGrid-virtualScroller": {
    overflowY: "auto",  
    overflowX: "auto",
  },

  "& .sticky-cell": {
    position: "sticky",
    backgroundColor: "white",
    zIndex: 1,
  },

  "& .sticky-header": {
    position: "sticky",
    backgroundColor: "white",
    zIndex: 2,
    top: 0,
  },

  "& .left-sticky-1": {
    left: 0,
    zIndex: 3,
  },

  "& .right-sticky-1": {
    right: 0,
    zIndex: 3,
  },

  "& .right-sticky-2": {
    right: 140,
    zIndex: 3,
  },

  "& .right-sticky-3": {
    right: 280,
    zIndex: 3,
  },

  "@media (max-width: 600px)": {
    "& .MuiDataGrid-columnHeaders": {
      fontSize: "0.85rem",
    },
    "& .MuiDataGrid-cell": {
      fontSize: "0.85rem",
    },
    "& .MuiTablePagination-root": {
      fontSize: "0.85rem",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontSize: "0.75rem",          // 🔥 smaller font for mobile
      whiteSpace: "pre-line",       // 🔥 mobile wrapping
      lineHeight: 1.1,
      textAlign: "center",
    },
  },
};

export default dataGridStyles;
